import { render } from "./AccountRecovery.vue?vue&type=template&id=30c4702e&scoped=true&ts=true"
import script from "./AccountRecovery.vue?vue&type=script&lang=ts"
export * from "./AccountRecovery.vue?vue&type=script&lang=ts"

import "./AccountRecovery.vue?vue&type=style&index=0&id=30c4702e&lang=css&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30c4702e"]])

export default __exports__